/**
 * The company id and club slug a venue route starts with (`/:companyId/:clubSlug/…`).
 * CompanyClubProvider and CompanyAuthContextProvider must read the URL the same way: the second
 * looks up the company-club the first caches under these two values.
 */
export const getVenueFromPath = (pathname: string) => {
  const [, companyId, clubSlug] = pathname.split('/');
  return { companyId, clubSlug };
};
